<template>
  <div class="header-warp">
    <div class="pc-header">
      <div
        class="header"
        :class="`${this.$route.meta.background ? 'header-background' : ''}`"
      >
        <div class="warp">
          <div class="header-flex-box">
            <div class="topLeftBox">
              <div class="logo">
                <div style="display: flex; cursor: pointer" @click="clear">
                  <img
                    height="67px"
                    :src="
                      require(`@/assets/images/cereshop/home/main_logo${
                        this.$route.meta.background ? '_white' : ''
                      }.png`)
                    "
                  />
                  <!-- <span>{{this.$route.meta.logoText}}</span> -->
                  <!-- background:url(${require(`@/assets/images/b2b_logo${this.$route.meta.background?'_white':''}.png`)}) no-repeat center;
                    background-size:contain; -->
                  <!-- <span
                    :style="`
                    width: 147px;
                    height: 21px;
                    
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  `"
                  > -->
                  <span
                    style="
                      width: 147px;
                      height: 67px;
                      line-height: 67px;
                      margin-left: 10px;
                    "
                  >
                    <img
                      style="width: 100%"
                      :src="
                        require(`@/assets/images/b2b_logo${
                          this.$route.meta.background ? '_white' : ''
                        }.svg`)
                      "
                      alt=""
                      srcset=""
                    />
                  </span>
                </div>
              </div>
              <div
                style="display: none"
                class="shopInfo cur-poi"
                v-if="this.$route.name === 'productDetail'"
                @click="toStore"
              >
                <!-- <div class="avatarClass">
                  <img :src="collectData.shopLogo" alt="">
                </div> -->
                <div class="shopData">
                  <div class="shopName">{{ collectData.shopName }}</div>
                  <div class="shopType">
                    <span>商品种类：{{ collectData.classifyNumber }}</span
                    ><span>已售：{{ collectData.number }}件</span>
                  </div>
                </div>
              </div>
              <!-- <div class="shopInfo" v-if="this.$route.name === 'store'">
                <div class="shopData">
                  <div class="shopName">{{collectData.shopName}}</div>
                  <div class="shopType"><span>所在地：{{collectData.shopAdress}}</span></div>
                </div>
                <div class="favoritesBox cur-poi" @click="collect">
                  <img style="width:18px;height:18px;margin-top:3px;" v-if="collectData.ifCollect === 0" src="../../../../../static/image/sc0.png" alt="">
                  <img style="width:18px;height:18px;margin-top:3px;" v-else src="../../../../../static/image/sc1.png" alt="">
                  <div class="text">收藏</div>
                </div>
              </div> -->
            </div>
            <div style="width: 10%"></div>
            <!-- <div class="search-box" v-if="this.$route.meta.searchVisible"> -->
            <div class="search-box">
              <div class="search">
                <div class="searchSelect">
                  <el-dropdown @command="searchCommand" trigger="click">
                    <span class="el-dropdown-link"
                      >{{ searchVal }}
                      <i class="el-icon-arrow-down cur-poi el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="商品">商品</el-dropdown-item>
                      <el-dropdown-item command="店铺">店铺</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div class="searchRight">
                  <input
                    type="text"
                    v-model="keyword"
                    @keyup.enter="searchPro"
                    :placeholder="
                      searchVal == '商品' ? '请输入搜索商品' : '请输入搜索店铺'
                    "
                  />
                </div>
                <span
                  v-if="this.$route.meta.background"
                  style="background: #f77b0b63; color: #f77b0b"
                  class="btn cur-poi"
                  @click="searchPro"
                  >搜索</span
                >
                <span v-else class="btn cur-poi" @click="searchPro">搜索</span>
              </div>
              <!-- <div class="hot-search" v-if="!this.$route.meta.background">
                  <img src="../../../../assets/images/fire.png" alt="" srcset="">
                  <span class="hot-search-title">热门搜索:</span>
                  <a @click="jumpCategory(item)" class="hot-search-port" v-for="item in hotClassify" :key="item.id">{{item.categoryName}}</a>
                </div> -->
            </div>
            <!-- <div
              class="myCart"
              v-if="this.$route.meta.searchVisible"
              @click="goToShopCart"
            > -->
            <div class="myCart" @click="goToShopCart">
              <span class="icon-The-shopping-cart">
                <span v-if="isShowNum && cartNumber !== 0">
                  {{ cartNumber }}
                </span>
              </span>
              我的采购单
            </div>
          </div>
          <div class="menu" v-if="this.$route.meta.menuVisible">
            <!-- <div class="menu"> -->
            <div
              class="menu-flag"
              @mouseleave="showClassify = false"
              @mouseenter="
                $route.name !== 'index' ? (showClassify = true) : null
              "
            >
              <div>
                <a-icon type="menu" />
                <span>商品分类</span>
              </div>
              <span
                class="el-icon-arrow-right"
                :class="`${showClassify ? 'turnDown' : ''}`"
              ></span>
              <div
                class="classify-outer"
                @mouseleave="showClassify = false"
                @mouseenter="showClassify = true"
                v-if="showClassify == true"
              >
                <cere-classification
                  :componentContent="componentContent"
                ></cere-classification>
              </div>
            </div>
            <ul>
              <li
                v-for="(item, index) in componentContent.labelList"
                :key="index"
              >
                <a
                  :class="{ active: isActive(item.name) }"
                  @click="jumpLink(item.linkObj)"
                  >{{ item.name }}</a
                >
              </li>
            </ul>
          </div>
          <div style="height: 34px" v-else></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { funMixin } from "../../config/mixin";
import api from "@/api";
import Cookie from "js-cookie";
import CereClassification from "./classification.vue";
export default {
  name: "cereHeader",
  mixins: [funMixin],
  components: { CereClassification },
  props: {
    componentContent: {
      type: Object,
    },
  },
  data() {
    return {
      showClassify: false,
      searchVal: localStorage.getItem("searchVal") || "商品",
      keyword: localStorage.getItem("keyword") || "",
      isShowNum: false,
      select: "",
      categoryData: [],
      componentContent: {},
    };
  },
  created() {
    
    this.componentContent = this.$store.state.componentContent[0].componentContent;
    console.log(this.componentContent);
    if (Cookie.get("token")) {
      this.isShowNum = true;
    }
  },
  computed: {
    ...mapGetters(["collectData", "cartNumber", "classify"]),
    hotClassify() {
      let arr = [];
      this.classify.map((item) => {
        item.childs.map((obj) => {
          obj.rootName = item.categoryName;
        });
        arr = arr.concat(item.childs);
      });
      let _arr = [];
      for (let i = 0; i < 4; i++) {
        _arr.push(arr[Math.floor(Math.random() * arr.length)]);
      }
      return _arr;
    },
  },
  destroyed() {
    window.removeEventListener("popstate", this.goBack, false);
  },
  mounted() {
    if (window.history && window.history.pushState) {
      // 向历史记录中插入了当前页
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.goBack, false);
    }
    this.getClassifyInfo();
    console.log(this.componentContent);
  },
  methods: {
    ...mapMutations({
      setSearchObj: "SET_SEARCHOBJ",
      setCollectData: "SET_COLLECTDATA",
    }),
    getClassifyInfo() {
      let self = this;
      let _url = api.getClassify + ``;
      // if (self.activeName !== "all") {
      //   _url += `&classifyId=${self.activeName}`;
      // }
      let params = {
        url: _url,
        method: "GET",
        data: {},
      };
      this.sendReq(params, (res) => {
        if (res.code === "200") {
          self.categoryData = res.data;
          // self.total = res.data.page.total;
          console.log(self.categoryData);
          this.$store.state.componentContent.category = self.categoryData
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    clear() {
      localStorage.removeItem("keyword");
      this.$router.push("/");
    },
    goToShopCart() {
      this.$router.push({ path: "/shopping-trolley" });
    },
    toStore() {
      console.log(this.collectData.shopId, "shopId");
      this.$router.push({
        path: "/store",
        query: {
          shopId: this.collectData.shopId,
        },
      });
    },
    collect() {
      if (this.collectData.ifCollect === 0) {
        let params = {
          url: api.collect,
          method: "POST",
          data: {
            shopId: this.collectData.shopId,
          },
        };
        this.sendReq(params, (res) => {
          if (res.code === "200") {
            let data = {
              shopName: this.collectData.shopName,
              shopAdress: this.collectData.shopAdress,
              collectId: this.collectData.collectId,
              ifCollect: 1,
              classifyNumber: res.data.classifyNumber,
              number: res.data.number,
              shopLogo: res.data.shopLogo,
            };
            this.setCollectData(data);
            this.$message.success("收藏成功");
          }
        });
      } else {
        let params = {
          url: api.unfavorite,
          method: "PUT",
          data: {
            ids: [this.collectData.collectId],
          },
        };
        this.sendReq(params, (res) => {
          if (res.code === "200") {
            let data = {
              shopName: this.collectData.shopName,
              shopAdress: this.collectData.shopAdress,
              collectId: this.collectData.collectId,
              ifCollect: 0,
              classifyNumber: res.data.classifyNumber,
              number: res.data.number,
              shopLogo: res.data.shopLogo,
            };
            this.setCollectData(data);
            this.$message.success("取消成功");
          }
        });
      }
    },
    searchCommand(command) {
      this.searchVal = command;
      localStorage.setItem("searchVal", command);
    },
    searchPro() {
      this.setSearchObj({
        keyword: this.keyword,
        searchVal: this.searchVal,
      });
      if (this.$route.name !== "search") {
        localStorage.setItem("keyword", this.keyword);
        this.$router.push({
          path: "/search",
        });
      }
    },
    goBack() {
      this.keyword = "";
    },
    isActive(name) {
      let curName = "";
      if (this.$route.query.classifyData) {
        curName = JSON.parse(this.$route.query.classifyData).categoryName;
      }
      if (curName === name && this.$route.name === "category") {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.site-nav {
  height: 42px;
  background-color: #f1f2f7;
  line-height: 42px;
  .left {
    float: left;
    span {
      color: $mainColor;
      cursor: pointer;
    }
  }
  .right {
    float: right;
    .item {
      padding: 0 15px;
      display: inline-block;
      span {
        cursor: pointer;
        b {
          color: $mainColor;
          padding: 0 2px;
        }
      }
      .iconfont {
        margin-right: 5px;
      }
      .icon-user {
        font-size: 14px;
      }
      &.item-select {
        padding-right: 33px;
        position: relative;
        .ico-arrow {
          position: absolute;
          right: 15px;
          top: 0;
          margin-right: 0;
        }
      }
      &:hover {
        background-color: #fff;
        .cart-no-data,
        .cart-no-login {
          display: flex;
        }
        .cart-list,
        .user-box {
          display: block;
        }
        .hover-item {
          color: $mainColor;
        }
      }
    }
  }
  .cart-box {
    position: absolute;
    top: 100%;
    background-color: #fff;
    z-index: 9;
    border-radius: 0px 0px 4px 4px;
    box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.06);
    &.cart-no-login {
      width: 100%;
      left: 0;
      height: 160px;
      display: none;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .btn {
        display: inline-block;
        padding: 0 15px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        color: #fff;
        background-color: $mainColor;
        border-radius: 4px;
        margin-bottom: 40px;
        cursor: pointer;
      }
      .p {
        color: #666666;
        line-height: 1em;
      }
    }
    &.cart-no-data {
      width: 264px;
      height: 110px;
      left: 50%;
      margin-left: -132px;
      display: none;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #666;
    }
    &.cart-list {
      width: 348px;
      left: 50%;
      margin-left: -174px;
      display: none;
      padding: 10px;
      dl {
        margin-bottom: 10px;
        dt {
          float: left;
          cursor: pointer;
        }
        dd {
          margin-left: 54px;
          position: relative;
          padding-right: 60px;
          min-height: 42px;
          line-height: 21px;
          h4 {
            color: #333;
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          p {
            color: #999;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          span {
            color: $mainColor;
            position: absolute;
            top: 0;
            right: 0;
          }
          .btn-del {
            color: #333;
            position: absolute;
            top: 20px;
            right: 0;
          }
        }
      }
      .btn-view-all {
        display: inline-block;
        float: right;
        padding: 0 15px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        color: #fff;
        background-color: $mainColor;
        border-radius: 4px;
        margin-top: 10px;
        cursor: pointer;
      }
    }
    &.user-box {
      width: 100%;
      left: 0;
      padding: 18px 0;
      display: none;
      li {
        display: block;
        cursor: pointer;
        color: #666;
        text-align: center;
        &:hover {
          background-color: #ffeee3;
        }
      }
    }
  }
}
.myCart {
  background: #fff;
  width: 144px;
  height: 61px;
  border-radius: 4px;
  border: 1px solid #f77b0b;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #333333;
  cursor: pointer;
  border-radius: 61px;
  .icon-The-shopping-cart {
    position: relative;
    margin-right: 10px;
    span {
      position: absolute;
      width: 20px;
      height: 19px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 13px;
      background: #ff4747;
      border-radius: 50%;
      right: -11px;
      top: -7px;
    }
  }
  .icon-The-shopping-cart:before {
    color: #f77b0b;
    font-size: 22px;
  }
}
.myCart:hover {
  opacity: 0.8;
  color: #f77b0b;
}
.header {
  background-color: #fff;
  // height: 98px;
  .header-flex-box {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding-top: 27px;
    .topLeftBox {
      display: flex;
      align-items: center;
      .shopInfo {
        display: flex;
        padding-left: 20px;
        border-left: 1px solid #f0f0f0;
        .avatarClass {
          width: 50px;
          height: 50px;
          margin-right: 13px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .shopData {
          .shopName {
            font-size: 18px;
            color: #333333;
            margin-bottom: 13px;
          }
          .shopType {
            font-size: 14px;
            color: #999999;
            margin-right: 14px;
            span {
              margin-right: 13px;
            }
          }
        }
        .favoritesBox {
          margin-left: 20px;
          width: 40px;
          height: 40px;
          border: 1px solid #d7d7d7;
          border-radius: 3px;
          text-align: center;
          .star {
            color: #fec200;
            font-size: 16px;
            margin: 2px auto;
          }
          .text {
            color: #999999;
            font-size: 12px;
          }
        }
      }
      .logo {
        // margin: 32px 15px 32px 0;
        a {
          display: flex;
          align-items: center;
          i {
            width: 1px;
            height: 42px;
            border: 1px solid #dfdcdc;
            margin-left: 14px;
          }
          span {
            padding-left: 12px;
            font-size: 20px;
            font-family: lianmengqiyilushuaizhengruiheiti-Regular,
              lianmengqiyilushuaizhengruiheiti;
            font-weight: 400;
            color: #333333;
            letter-spacing: 3px;
          }
        }
      }
    }
    .menu {
      padding: 35px 0;
      li {
        display: inline-block;
        line-height: 28px;
        margin: 0 10px;
        a {
          display: block;
          cursor: pointer;
          font-size: 18px !important;
          &:hover {
            color: $mainColor;
          }
        }
      }
    }
    .search-box {
      position: relative;
      .search {
        // width: 40%;
        // max-width: 100%;
        width: 745px;
        border: 1px solid $mainColor;
        border-radius: 4px;
        height: 61px;
        overflow: hidden;
        // margin: 25px 0;
        background: #fff;
        position: relative;
        display: flex;
        border-radius: 61px;
        align-items: center;
        padding-left: 15px;
        .searchSelect {
          margin: 12px 10px 12px 0;
          height: 22px;
          line-height: 22px;
          padding: 0 12px;
          border-right: 1px solid #e5e5e5;
          >>> .el-dropdown-link {
            font-size: 20px;
            color: #666;
          }
        }
        .searchRight {
          flex: 1;
          position: relative;
          height: 46px;
          .icon {
            position: absolute;
            left: 11px;
            top: 50%;
            margin-top: -8px;
            color: #666;
            font-size: 16px;
          }
          input {
            padding: 0 60px 0 35px;
            width: 100%;
            height: 46px;
            font-size: 14px;
            box-sizing: border-box;
          }
        }
        .btn {
          width: 104px;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 61px;
          border-radius: 61px;
          background: linear-gradient(90deg, #ff871b 0%, #ff5523 100%);
          // background-color: $mainColor;
          color: #fff;
          cursor: pointer;
          font-size: 20px;
          margin-right: -2px;
        }
      }
      .hot-search {
        position: absolute;
        bottom: -35px;
        height: 30px;
        width: 100%;
        display: flex;
        align-items: center;
        img {
          height: 20px;
          margin-right: 4px;
          margin-top: -4px;
          margin-left: 10px;
        }
        .hot-search-title {
          font-size: 14px;
          color: #ff4747;
          margin-right: 19px;
        }
        .hot-search-port {
          cursor: pointer;
          margin-right: 35px;
          font-size: 14px;
          color: #606266;
        }
        .hot-search-port:hover {
          color: #f77b0b;
        }
      }
    }
  }
  .menu {
    padding: 29px 0 0 0;
    display: flex;
    align-items: center;
    .menu-flag {
      width: 250px;
      height: 55px;
      background: linear-gradient(180deg, #ff871b 0%, #ff5523 100%);
      border-radius: 8px 8px 0px 0px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      color: #fff;
      font-size: 20px;
      cursor: default;
      position: relative;
      & > div {
        display: flex;
        align-items: center;
      }
      .anticon-menu {
        font-size: 24px;
        margin-right: 27px;
      }
      .el-icon-arrow-right {
        transition: all 0.3s;
        transform: rotate(0);
      }
      .turnDown {
        transform: rotate(90deg);
      }
      .classify-outer {
        position: absolute;
        left: 0px;
        top: 55px;
        width: 315px;
        padding: 0;
        height: 0;
        // overflow: hidden;
        transition: all 0.3s;
      }
      .showClassify {
        height: 717px;
      }
    }
    & > ul {
      height: 55px !important;
      line-height: 55px;
    }
    li {
      display: inline-block;
      line-height: 28px;
      a {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        display: block;
        cursor: pointer;
        padding: 0 50px 0 0;
        &:hover {
          color: $mainColor;
        }
      }
      .active {
        color: $mainColor;
      }
    }
    li:first-child {
      padding-left: 46px;
    }
  }
}
.header-background {
  background: url(../../../../assets/images/header-backImg.png) no-repeat center;
  background-size: cover;
}
@media screen and (max-width: 1200px) {
  .header {
    display: block;
    position: relative;
    height: auto;
    .header-flex-box {
      align-items: center;
      .logo {
        position: absolute;
        left: 1%;
      }
      .menu {
        margin-top: 90px;
        padding: 0 0 20px 0;
        width: 100%;
        display: flex;
        justify-content: center;
        .classify-outer {
        }
      }
      .search {
        position: absolute;
        right: 1%;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .pc-header {
    display: none;
  }
  .phone-header {
    display: flex;
    justify-content: space-between;
  }
}
.device-xiaochengxu,
.device-h5,
.device-phone {
  .pc-header {
    display: none;
  }
  .phone-header {
    display: flex;
    justify-content: space-between;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/canvasShow/cereshop/pc/header.vue